import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ApiHelper } from "../../utils/apiHelper";
import { toast } from "react-toastify";

export const createStartup = createAsyncThunk(
    "startup/create",
    async (startup, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.post("/startup/create", startup);
            if (response.data.code === "00000") {
                toast.success('Yeni kampanya başarıyla oluşturuldu');
                return response.data;
            } else {
                throw new Error("Startup creation failed");
            }
        } catch (error) {
            toast.error('Kampanya oluşturulurken bir hata oluştu');
            return rejectWithValue(error.message || "An error occurred");
        }
    }
);

export const fetchStartup = createAsyncThunk(
    "startup/fetch",
    async (startupId, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.get(`/startup/${startupId}`);
            if (response.data.code === "00000") {
                toast.success('Kampanya bilgileri başarıyla yüklendi');
                return response.data.startup;
            }
            throw new Error("Failed to fetch startup");
        } catch (error) {
            toast.error('Kampanya bilgileri yüklenirken bir hata oluştu');
            return rejectWithValue(error.message);
        }
    }
);

export const updateStartup = createAsyncThunk(
    "startup/update",
    async (startupData, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.put("/startup/update", startupData);
            if (response.data.code === "00000") {
                toast.success('Kampanya bilgileri başarıyla güncellendi');
                return startupData;
            }
            throw new Error("Failed to update startup");
        } catch (error) {
            toast.error('Kampanya bilgileri güncellenirken bir hata oluştu');
            return rejectWithValue(error.message);
        }
    }
);

const startupSlice = createSlice({
    name: "startup",
    initialState: {
        startup: null,
        loading: false,
        error: null,
    },
    reducers: {
        create: (state, action) => {
            state.startup = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createStartup.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createStartup.fulfilled, (state, action) => {
                state.loading = false;
                state.startup = { ...state.startup, ...action.payload };
            })
            .addCase(createStartup.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchStartup.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchStartup.fulfilled, (state, action) => {
                state.loading = false;
                state.startup = action.payload;
            })
            .addCase(fetchStartup.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateStartup.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateStartup.fulfilled, (state, action) => {
                state.loading = false;
                state.startup = { ...state.startup, ...action.payload };
            })
            .addCase(updateStartup.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { create } = startupSlice.actions;
export default startupSlice.reducer;
